import { OffersGetAllQuery } from '../types';

export const offersFilterListMode = (
  data: OffersGetAllQuery['data'],
  listMode: string,
): OffersGetAllQuery['data'] => {
  if (listMode === 'All') return data;

  const byContainer = new Map<string, OffersGetAllQuery['data'][number]>();
  data.forEach((item) => {
    const key = item.container.number;
    const prev = byContainer.get(key);
    if (!prev) {
      byContainer.set(key, item);
      return;
    }
    if (new Date(item.createdAt) > new Date(prev.createdAt)) {
      byContainer.set(key, item);
    }
  });
  return Array.from(byContainer.values());
};
